const API_URL = 'https://myblrc.in/api/api.php';
const READ_URL = process.env.NODE_ENV === 'development'
  ? '/api/api.php'
  : 'https://myblrc.in/api/api.php';
const READER_KEY = 'brlc_vid';
const READER_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

async function readJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}

function dataOf(payload) {
  return payload && payload.data ? payload.data : null;
}

export async function fetchPublishedBlogs({ page = 1, limit = 6 } = {}) {
  const params = new URLSearchParams({
    xAction: 'getPublishedBlogs',
    page: String(page),
    limit: String(limit),
  });
  let response;
  try {
    response = await fetch(`${API_URL}?${params.toString()}`, {
      headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    });
  } catch (error) {
    throw new Error('Unable to reach the blog service. Please try again.');
  }
  const payload = await readJson(response);
  const data = dataOf(payload);
  if (!response.ok || !data || data.status === 'error') {
    throw new Error((data && data.message) || 'Unable to load published case studies.');
  }
  return {
    blogs: Array.isArray(data.blogs) ? data.blogs : [],
    pagination: data.pagination || {
      current_page: page,
      per_page: limit,
      total_records: 0,
      total_pages: 0,
      has_next_page: false,
      has_prev_page: false,
    },
  };
}

export async function fetchPublishedBlog(slug) {
  const params = new URLSearchParams({
    xAction: 'getPublishedBlog',
    slug: String(slug || ''),
  });
  let response;
  try {
    response = await fetch(`${API_URL}?${params.toString()}`, {
      headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    });
  } catch (error) {
    throw new Error('Unable to reach the blog service. Please try again.');
  }
  const payload = await readJson(response);
  const data = dataOf(payload);
  if (response.status === 404) {
    return null;
  }
  if (!response.ok || !data || data.status === 'error') {
    throw new Error((data && data.message) || 'Unable to load this case study.');
  }
  return data.blog || null;
}

function readerId() {
  const stored = window.localStorage.getItem(READER_KEY) || '';
  if (READER_PATTERN.test(stored)) return stored.toLowerCase();
  const id = window.crypto && typeof window.crypto.randomUUID === 'function'
    ? window.crypto.randomUUID().toLowerCase()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
      const random = Math.floor(Math.random() * 16);
      const value = character === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    });
  window.localStorage.setItem(READER_KEY, id);
  return id;
}

export async function recordBlogRead(slug) {
  let response;
  try {
    response = await fetch(`${READ_URL}?xAction=recordBlogRead`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ slug, visitor_id: readerId() }),
    });
  } catch (error) {
    return null;
  }
  const payload = await readJson(response);
  const data = dataOf(payload);
  if (!response.ok || !data || data.status === 'error') return null;
  return {
    read_count: Number(data.read_count) || 0,
    show_read_count: data.show_read_count === true || data.show_read_count === 1 || data.show_read_count === '1',
  };
}
